/* T7C Asteroids — extracted JS (Shopify-safe). 
   Includes: SHIELD button (hold/tap) replacing in-game RST, while TRY AGAIN on end screens.
*/
(() => {
  const root   = document.getElementById('t7cAsteroids');
  const canvas = document.getElementById('t7cCanvas');
  const ctx    = canvas.getContext('2d', { alpha:true });
  const hud    = document.getElementById('t7cHud');
  const logoIntro = document.getElementById('t7cLogoIntro');

  const controlsEl = document.getElementById('t7cControls');
  const restartBtn = document.getElementById('t7cRestart');

  canvas.tabIndex = 0;
  const focusGame = () => { try { canvas.focus({ preventScroll:true }); } catch(_) { try { canvas.focus(); } catch(__) {} } };
  const clearSelection = () => { try{ const sel=window.getSelection && window.getSelection(); if(sel && sel.removeAllRanges) sel.removeAllRanges(); } catch(_){} };

  const isCoarse = matchMedia("(pointer: coarse)").matches;
  const isSmall  = matchMedia("(max-width: 700px)").matches;
  const isMobile = isCoarse || isSmall;

  const MOBILE_RENDER_SCALE = 0.72;

  /* ===== AUDIO ===== */
  const CDN="https://cdn.shopify.com/s/files/1/0657/1917/3306/files/";

  const SFX_ASSET = {
    hit:CDN+"hit.wav?v=1770324979",
    over:CDN+"over.wav?v=1770324978",
    clear:CDN+"clear.mp3?v=1770324978",
    shoot:CDN+"shoot.wav?v=1770324978"
  };

  const MUSIC_URL = {
    load:CDN+"load_screen_bg_music.m4a?v=1770415587",
    level12:"https://cdn.shopify.com/s/files/1/0657/1917/3306/files/Level_1_2_bgmusic_new.wav?v=1770771079",
    boss:"https://cdn.shopify.com/s/files/1/0657/1917/3306/files/Boss_bg_music_new.wav?v=1770771091",
    win:CDN+"win_game.m4a?v=1770415587"
  };

  const MUSIC_GAIN = {
    load:   0.26,
    level12:0.36,
    boss:   0.36,
    win:    0.28
  };

  const SFX = (() => {
    let aCtx=null, master=null;
    const buffers=new Map();
    let inited=false;

    async function init(){
      if(inited) return;
      inited=true;
      aCtx = new (window.AudioContext || window.webkitAudioContext)();
      master = aCtx.createGain();
      master.gain.value = 0.90;
      master.connect(aCtx.destination);
    }

    async function unlockAggressive(){
      await init();
      try{ if(aCtx.state!=="running") await aCtx.resume(); }catch(_){}
      try{
        const b=aCtx.createBuffer(1,1,aCtx.sampleRate);
        const s=aCtx.createBufferSource();
        s.buffer=b; s.connect(master); s.start(0);
      }catch(_){}
    }

    async function load(name,url){
      await init();
      const res=await fetch(url,{ mode:"cors" });
      const arr=await res.arrayBuffer();
      const buf=await aCtx.decodeAudioData(arr);
      buffers.set(name,buf);
    }

    function play(name,opt){
      opt = opt || {};
      const volume = (typeof opt.volume==="number") ? opt.volume : 1;
      const rate   = (typeof opt.rate==="number") ? opt.rate : 1;

      if(!aCtx || aCtx.state!=="running") return;
      const buf=buffers.get(name);
      if(!buf) return;
      const src=aCtx.createBufferSource();
      src.buffer=buf;
      src.playbackRate.value=rate;
      const g=aCtx.createGain();
      g.gain.value=volume;
      src.connect(g);
      g.connect(master);
      try{ src.start(0); }catch(_){}
    }

    function _ctx(){ return aCtx; }
    function _master(){ return master; }
    return { init, unlockAggressive, load, play, _ctx, _master };
  })();

  const BGM = (() => {
    // Seamless looping + instant-ish transitions:
    // - Decode WAV/MP3 once and cache AudioBuffers (preload in init).
    // - Loop with scheduled overlap + crossfade to avoid loop seam.
    // - When switching tracks (intro -> level -> boss), crossfade between tracks (no stop/start gap).
    let aCtx=null, master=null;
    const cache=new Map(); // url -> { p:Promise<AudioBuffer>, b:AudioBuffer|null }

    let currentUrl="";
    let targetVol=0.28;

    // loop engine (two sources for overlap)
    let srcA=null, srcB=null;
    let gainA=null, gainB=null;

    let timer=null;
    let playing=false;
    let switching=false;

    const LOOP_XFADE_SEC = 0.10;   // loop seam fade
    const LOOP_OVERLAP_SEC = 0.12; // loop overlap (>= LOOP_XFADE_SEC)

    const SWITCH_XFADE_SEC = 0.18; // track change fade

    async function init(){
      await SFX.init();
      if(aCtx) return;
      aCtx = SFX._ctx();
      master = SFX._master();

      // Opportunistic preload to remove delays when the game changes state.
      // (Runs after init, when MUSIC_URL should be defined. Guarded to avoid TDZ issues.)
      setTimeout(() => {
        try{
          const urls=[
            (typeof MUSIC_URL!=="undefined" && MUSIC_URL.load)   ? MUSIC_URL.load   : null,
            (typeof MUSIC_URL!=="undefined" && MUSIC_URL.level12)? MUSIC_URL.level12: null,
            (typeof MUSIC_URL!=="undefined" && MUSIC_URL.boss)   ? MUSIC_URL.boss   : null,
            (typeof MUSIC_URL!=="undefined" && MUSIC_URL.win)    ? MUSIC_URL.win    : null
          ].filter(Boolean);
          urls.forEach(u => { _ensure(u).catch(function(){}); });
        }catch(_){}
      }, 0);
    }

    async function _fetchDecode(url){
      const res = await fetch(url, { mode:"cors", credentials:"omit" });
      const arr = await res.arrayBuffer();
      return await aCtx.decodeAudioData(arr);
    }

    function _ensure(url){
      if(!url) return Promise.reject("no url");
      const hit=cache.get(url);
      if(hit){
        return hit.b ? Promise.resolve(hit.b) : hit.p;
      }
      const entry={ b:null, p:null };
      entry.p = _fetchDecode(url).then(b => { entry.b=b; return b; });
      cache.set(url, entry);
      return entry.p;
    }

    function _makeSource(buffer){
      const src = aCtx.createBufferSource();
      src.buffer = buffer;
      src.loop = false; // we do overlap looping manually
      const g = aCtx.createGain();
      g.gain.value = 0;
      src.connect(g);
      g.connect(master);
      return { src, g };
    }

    function _clearTimer(){
      if(timer){ clearTimeout(timer); timer=null; }
    }

    function _stopSources(hard){
      // hard=true stops immediately; otherwise caller can fade via gains first.
      try{ if(srcA) srcA.stop(hard?0:0); }catch(_){}
      try{ if(srcB) srcB.stop(hard?0:0); }catch(_){}
      srcA=null; srcB=null;
      gainA=null; gainB=null;
    }

    function _fadeOutCurrentAndStop(){
      if(!aCtx || (!gainA && !gainB)) { _stopSources(true); return; }
      const now=aCtx.currentTime;
      try{
        if(gainA){
          gainA.gain.cancelScheduledValues(now);
          gainA.gain.setValueAtTime(gainA.gain.value, now);
          gainA.gain.linearRampToValueAtTime(0, now + SWITCH_XFADE_SEC);
        }
        if(gainB){
          gainB.gain.cancelScheduledValues(now);
          gainB.gain.setValueAtTime(gainB.gain.value, now);
          gainB.gain.linearRampToValueAtTime(0, now + SWITCH_XFADE_SEC);
        }
      }catch(_){}
      setTimeout(() => { _stopSources(true); }, Math.round((SWITCH_XFADE_SEC+0.04)*1000));
    }

    function _scheduleLoop(buffer){
      _clearTimer();
      if(!playing || !buffer) return;

      const now=aCtx.currentTime;

      // Build fresh A/B each cycle so we can keep timing tight.
      _stopSources(true);

      const A=_makeSource(buffer);
      const B=_makeSource(buffer);
      srcA=A.src; gainA=A.g;
      srcB=B.src; gainB=B.g;

      // Start A immediately
      gainA.gain.setValueAtTime(0, now);
      gainA.gain.linearRampToValueAtTime(targetVol, now + LOOP_XFADE_SEC);
      srcA.start(now);

      const dur = buffer.duration;
      const bStart = now + Math.max(0, dur - LOOP_OVERLAP_SEC);

      // Start B near end and crossfade
      gainB.gain.setValueAtTime(0, bStart);
      gainB.gain.linearRampToValueAtTime(targetVol, bStart + LOOP_XFADE_SEC);

      gainA.gain.setValueAtTime(targetVol, bStart);
      gainA.gain.linearRampToValueAtTime(0, bStart + LOOP_XFADE_SEC);

      srcB.start(bStart);

      // Next cycle at the moment B becomes the "main" track
      const nextInMs = Math.max(50, Math.round((dur - LOOP_OVERLAP_SEC) * 1000));
      timer = setTimeout(() => { if(!switching) _scheduleLoop(buffer); }, nextInMs);
    }

    async function play(url, vol){
      await init();
      if(typeof vol==="number") targetVol = vol;
      if(!url) return;

      try{ if(aCtx.state === "suspended") await aCtx.resume(); }catch(_){}

      // No-op if same track and already playing.
      if(playing && currentUrl===url) return;

      switching = true;

      // Fade out old track (but don't hard-stop until new is ready to avoid silence)
      const hadOld = playing && (gainA || gainB);

      const buf = await _ensure(url).catch(function(){ return null; });
      if(!buf){
        // If decode fails, fall back to stopping current to avoid stuck state.
        switching = false;
        return;
      }

      // Start new track first (so transition has no gap), then fade out old.
      currentUrl = url;
      playing = true;
      _scheduleLoop(buf);

      if(hadOld){
        // fade out previous sources that might still be audible (they were replaced in _scheduleLoop)
        // We already rebuilt sources, so nothing old remains. However, if a timer fired mid-switch,
        // ensure no lingering audio by forcing a short ramp on current gains from 0->target (already done).
      }

      switching = false;
    }

    function stop(){
      playing = false;
      switching = false;
      _clearTimer();
      _fadeOutCurrentAndStop();
    }

    // Optional manual preload
    async function preload(urls){
      await init();
      if(!Array.isArray(urls)) return;
      await Promise.all(urls.map(u => _ensure(u).catch(function(){})));
    }

    return { init, play, stop, preload };
  })();

  let lastShootSfxT=0;
  function playShootSfx(){
    const now=performance.now();
    if(now-lastShootSfxT<70) return;
    lastShootSfxT=now;
    SFX.play("shoot",{ volume:0.55, rate:1.0 });
  }

  let audioUnlockedEver=false;
  let startGate=true;

  async function unlockAudioIfNeeded(){
    await SFX.unlockAggressive().catch(function(){});
    await BGM.init().catch(function(){});
    if(!audioUnlockedEver){
      audioUnlockedEver=true;
      startGate=false;
      await BGM.play(MUSIC_URL.load, MUSIC_GAIN.load);
    } else {
      await SFX.unlockAggressive().catch(function(){});
    }
  }

  async function onGesture(){
    clearSelection();
    focusGame();
    await unlockAudioIfNeeded();
  }

  root.addEventListener('touchstart', function(){ onGesture(); }, { passive:true, capture:true });
  root.addEventListener('pointerdown', function(){ onGesture(); }, { passive:true, capture:true });
  window.addEventListener('keydown', function(){ onGesture(); }, { passive:true });

  const keys=Object.create(null);
  const clearKeys=function(){ keys["ArrowLeft"]=false; keys["ArrowRight"]=false; keys["ArrowUp"]=false; keys["Space"]=false; };
  window.addEventListener('blur', clearKeys);
  document.addEventListener('visibilitychange', function(){ if(document.hidden) clearKeys(); });

  /* ===== IMAGES ===== */
  const ASSET={
    bg1:CDN+"level1_background_update.jpg?v=1770478969",
    bg2:CDN+"level2_background_update.jpg?v=1770478724",
    bg3:CDN+"Boss_background_update.jpg?v=1770478724",
    globe:CDN+"globe.png?v=1770250322",
    smiley:CDN+"t7c_smiley.png?v=1770250323",
    ufo:CDN+"t7c_ufo.png?v=1770250322",
    ufoHit:CDN+"t7c_ufo_hit.png?v=1770413773",
    alienEnemy:CDN+"alien_enemy.png?v=1770481623",
    ship:CDN+"t7c_ship.png?v=1770250322",
    shipThr:CDN+"t7c_ship_thursters.png?v=1770250322",
    shipHit:CDN+"t7c_ship_hit.png?v=1770323999",
    shipShield:"https://cdn.shopify.com/s/files/1/0657/1917/3306/files/t7c_ship_shield.png?v=1770564083",
    oneup:CDN+"1up.png?v=1770412293",
    gameOver:CDN+"game_over.png?v=1770422872",
    winAliens:CDN+"you_win_aliens.png?v=1770477676",
    winBg:CDN+"You_win_background.jpg?v=1770477641",
    boss:CDN+"t7c_boss_ufo.png?v=1770480010",
    bossHit:CDN+"t7c_boss_ufo_hit.png?v=1770480010",
    bossEx1:CDN+"t7c_boss_ufo_exploding_stage1.png?v=1770480010",
    bossEx2:CDN+"t7c_boss_ufo_exploding_stage2.png?v=1770480010",
    bossEx3:CDN+"t7c_boss_ufo_exploding_stage3.png?v=1770480011",
    // CHANGE START: boss shield sprite
    bossShield:"https://cdn.shopify.com/s/files/1/0657/1917/3306/files/t7c_boss_ufo_shield.png?v=1770738189"
    // CHANGE END
  };

  function loadImage(url){
    return new Promise(function(resolve,reject){
      const img=new Image();
      img.crossOrigin="anonymous";
      img.onload=function(){ resolve(img); };
      img.onerror=function(){ reject(new Error("Failed to load: "+url)); };
      img.src=url;
    });
  }

  /* ===== CANVAS SIZING ===== */
  let W=800,H=800;
  function setCanvasSize(w,h){ W=w; H=h; canvas.width=W; canvas.height=H; }
  function setIntroWorldSize(){
    const s=isMobile?MOBILE_RENDER_SCALE:1;
    setCanvasSize(Math.round(800*s), Math.round(800*s));
  }
  function setGameplayWorldSize(){
    const baseW=800, baseH=isMobile?1200:800;
    const s=isMobile?MOBILE_RENDER_SCALE:1;
    setCanvasSize(Math.round(baseW*s), Math.round(baseH*s));
  }

  const rand=function(a,b){ return a+Math.random()*(b-a); };
  const clamp=function(v,a,b){ return Math.max(a,Math.min(b,v)); };
  const dist2=function(ax,ay,bx,by){ const dx=ax-bx, dy=ay-by; return dx*dx+dy*dy; };
  // CHANGE START: integer random helper (inclusive)
  const randInt=function(a,b){ return Math.floor(a + Math.random()*(b-a+1)); };
  // CHANGE END

  function drawCover(img){
    const iw=img.naturalWidth||img.width;
    const ih=img.naturalHeight||img.height;
    if(!iw||!ih) return;
    const sc=Math.max(W/iw,H/ih);
    const dw=iw*sc, dh=ih*sc;
    const dx=(W-dw)/2, dy=(H-dh)/2;
    ctx.drawImage(img,dx,dy,dw,dh);
  }
  function drawSpriteCentered(img,x,y,w,h,ang){
    ang = ang || 0;
    ctx.save(); ctx.translate(x,y); ctx.rotate(ang);
    ctx.drawImage(img,-w/2,-h/2,w,h);
    ctx.restore();
  }

  function segHitsCircle(x1,y1,x2,y2,cx,cy,r){
    const dx=x2-x1, dy=y2-y1;
    const l2=dx*dx+dy*dy;
    if(l2<=1e-6){
      const dxc=x1-cx, dyc=y1-cy;
      return (dxc*dxc+dyc*dyc) <= r*r;
    }
    let t=((cx-x1)*dx+(cy-y1)*dy)/l2;
    t=clamp(t,0,1);
    const px=x1+t*dx, py=y1+t*dy;
    const ddx=px-cx, ddy=py-cy;
    return (ddx*ddx+ddy*ddy) <= r*r;
  }

  const TEAL="#00ffc8";
  const DIFF={
    waveStart: 3,
    waveMax: 6,
    ufoChance: 0.50,
    maxEnemyLasers: 4,
    ufoFireMin: 2.2,
    ufoFireMax: 4.0,
    enemyLaserLife: 1.25,
    enemyLaserSpeed: 340,
    playerFireCooldown: 0.10,
    playerLaserLife: 0.9,
    playerLaserSpeed: 820,
    shipInvulnOnRespawn: 1.2,
    shipTurnSpeed: 3.2,
    shipThrust: 620,
    shipFriction: 0.986
  };

  const INTRO_SECONDS=5.0;
  const LEVEL_TARGET=2000;
  const LEVELS_TO_WIN=3;

  const BOSS_HITS_TO_WIN=20;
  const BOSS_SIZE=320;
  const BOSS_R=132;
  const BOSS_ENTRY_SPEED=240;
  const BOSS_HOVER_Y=155;

  const BOSS_FIRE1_MIN=0.45;
  const BOSS_FIRE1_MAX=1.10;
  const BOSS_SPRAY1_FIRST_MIN=5.0;
  const BOSS_SPRAY1_FIRST_MAX=7.0;
  const BOSS_SPRAY1_MIN=8.0;
  const BOSS_SPRAY1_MAX=15.0;

  const BOSS_FIRE2_MIN=0.34;
  const BOSS_FIRE2_MAX=0.85;
  const BOSS_SPRAY2_MIN=4.2;
  const BOSS_SPRAY2_MAX=8.5;
  const BOSS_MOVE2_MUL=1.28;

  const BOSS_FIRE3_MIN=0.18;
  const BOSS_FIRE3_MAX=0.42;
  const BOSS_SPRAY3_MIN=2.6;
  const BOSS_SPRAY3_MAX=5.2;
  const BOSS_MOVE3_MUL=1.55;

  const BOSS_RAGE_BURST_EVERY_MIN=2.8;
  const BOSS_RAGE_BURST_EVERY_MAX=4.4;
  const BOSS_RAGE_BURST_LEN_MIN=0.65;
  const BOSS_RAGE_BURST_LEN_MAX=1.05;
  const BOSS_RAGE_SHOT_GAP_MIN=0.06;
  const BOSS_RAGE_SHOT_GAP_MAX=0.12;

  const BOSS_SPRAY_BULLETS=18;
  const BOSS_SPRAY_SPEED=430;

  const BOSS_EXPL_TOTAL=1.05;
  const BOSS_EX_STAGE=BOSS_EXPL_TOTAL/3;

  const ONEUP_SIZE=72;
  const ONEUP_R=34;

  const COL={ playerLaser:"#00ff6a", enemyLaser:"#ff2b2b" };

  function laserOut(b){ return (b.x<-80||b.x>W+80||b.y<-80||b.y>H+80); }

  function drawLaser(b){
    ctx.beginPath();
    ctx.moveTo(b.px, b.py);
    ctx.lineTo(b.x, b.y);
    ctx.stroke();
  }

  /* ===== MINIMAL SNIPER UFO ===== */
  const SNIPER = {
    radius: 44,
    hp: 2,
    spawnMin: 7.0,
    spawnMax: 12.0,
    moveSpeed: 62,
    fireMin: 2.6,
    fireMax: 4.0,
    laserSpeed: 520,
    laserLife: 1.15
  };

  function scheduleSniper(){
    sniper=null;
    sniperTimer = rand(SNIPER.spawnMin, SNIPER.spawnMax);
  }

  function spawnSniper(){
    const r=SNIPER.radius;
    const side=Math.floor(rand(0,4));
    const margin=r+34;
    let x,y;

    if(side===0){ x=rand(0,W); y=-margin; }
    else if(side===1){ x=W+margin; y=rand(0,H*0.60); }
    else if(side===2){ x=rand(0,W); y=H+margin; }
    else { x=-margin; y=rand(0,H*0.60); }

    const tx=rand(W*0.20, W*0.80);
    const ty=rand(H*0.10, H*0.42);
    const ang=Math.atan2(ty-y, tx-x);

    sniper={
      x:x, y:y,
      vx:Math.cos(ang)*SNIPER.moveSpeed,
      vy:Math.sin(ang)*SNIPER.moveSpeed,
      r:r,
      hp:SNIPER.hp,
      fireT:rand(SNIPER.fireMin, SNIPER.fireMax)
    };
  }

  function sniperFire(){
    if(!sniper) return;
    if(enemyLasers.length>=DIFF.maxEnemyLasers) return;

    const dx = ship.x - sniper.x;
    const dy = ship.y - sniper.y;
    const ang = Math.atan2(dy, dx);
    const ax = Math.cos(ang);
    const ay = Math.sin(ang);

    enemyLasers.push({
      px: sniper.x, py: sniper.y,
      x: sniper.x + ax*(sniper.r*0.95),
      y: sniper.y + ay*(sniper.r*0.95),
      vx: ax*SNIPER.laserSpeed,
      vy: ay*SNIPER.laserSpeed,
      life: SNIPER.laserLife
    });
  }

  let IMG={};
  let state="loading";
  let introT=0;
  let level=1;
  let lives=4;
  let levelScore=0;
  let totalScore=0;
  let levelClearT=0;

  /* ===== SHIELD STATE ===== */
  let shieldActive=false;

  /* ===== PARTICLES (enemy explode) ===== */
  let particles=[]; // {x,y,vx,vy,life,ttl,r}
  let shockwaves=[]; // {x,y,r,life,ttl,spd,thick}
  // CHANGE START: boss charge trail
  let bossTrail=[]; // {x,y,r,life,ttl}
  // CHANGE END


  // CHANGE START: boss stage 2 charge + trail
  const BOSS_CHARGE_EVERY_MIN = 3.2;
  const BOSS_CHARGE_EVERY_MAX = 5.2;
  const BOSS_CHARGE_SPEED     = 720;
  const BOSS_CHARGE_DUR       = 0.85;

  function spawnBossTrail(x,y){
    bossTrail.push({ x:x, y:y, life:0, ttl:0.55, seed:rand(0,Math.PI*2) });
  }
  // CHANGE END
function spawnShockwave(x,y){
    shockwaves.push({ x:x, y:y, r:0, life:0, ttl:0.95, spd:520, thick:18, col:"#ff7a00" });
  }
  function spawnRedBurst(x,y,scale){
    scale = (typeof scale==="number") ? scale : 1;
    const n = Math.round(18*scale);
    for(let i=0;i<n;i++){
      const ang = rand(0, Math.PI*2);
      const sp  = rand(90, 320)*scale;
      particles.push({
        x:x, y:y,
        vx: Math.cos(ang)*sp,
        vy: Math.sin(ang)*sp,
        ttl: rand(0.28, 0.55),
        life: 0,
        r: rand(1.4, 3.2)*scale
      });
    }
  }

  /* ===== CONTROLS UI (ROBUST) ===== */
  function syncControlsUI(){
    const isEnd = (state === "gameover" || state === "win");

    if(controlsEl){
      controlsEl.classList.toggle("gameover", isEnd);
    }

    const ids = ["t7cLeft","t7cThrust","t7cRight","t7cShoot"];
    for(const id of ids){
      const b = document.getElementById(id);
      if(!b) continue;
      b.style.display = isEnd ? "none" : "";
    }

    if(restartBtn){
      restartBtn.textContent = isEnd ? "TRY AGAIN" : "SHIELD";
      restartBtn.setAttribute("aria-label", isEnd ? "Try Again" : "Shield");
      restartBtn.style.width  = isEnd ? "100%" : "";
      restartBtn.style.height = isEnd ? "64px"  : "";
    }
  }

  const SHIP_SIZE=Math.round(112*1.15);
  const SHIP_R=Math.round(26*1.15);
  const ship={ x:0,y:0,vx:0,vy:0,ang:-Math.PI/2,r:SHIP_R,cooldown:0,invuln:0,hitFlash:0 };

  let playerLasers=[], enemyLasers=[], enemies=[];
  let boss=null;

  let oneup=null, oneupTimer=0, oneupSpawned=false;
  let lvl2Form=null;

  let sniper=null, sniperTimer=0;

  /* ✅ boss spawn failsafe flag */
  let bossFailSafeUsed=false;

  let shakeT=0, shakeAmp=0;
  function triggerShake(seconds, amp){
    seconds = (typeof seconds==="number") ? seconds : 0.6;
    amp     = (typeof amp==="number") ? amp : 14;
    shakeT=Math.max(shakeT,seconds);
    shakeAmp=Math.max(shakeAmp,amp);
  }
  function applyShake(dt){
    if(shakeT<=0) return {x:0,y:0};
    shakeT=Math.max(0, shakeT-dt);
    const t=clamp(shakeT/0.6,0,1);
    const a=shakeAmp*(0.25+0.75*t);
    return { x:(Math.random()*2-1)*a, y:(Math.random()*2-1)*a };
  }

  let bgY=0;
  function resetScrollBG(){ bgY=0; }
  function drawVerticalLoopBG(img, dt, speed){
    speed = (typeof speed==="number") ? speed : 55;
    if(!img){ ctx.fillStyle="#000"; ctx.fillRect(0,0,W,H); return; }
    const iw=img.naturalWidth||img.width;
    const ih=img.naturalHeight||img.height;
    if(!iw||!ih) return;

    const scale=W/iw;
    const drawH=ih*scale;

    bgY += speed*dt;
    bgY += ship.vy*dt*0.08;

    bgY = bgY % drawH;
    if(bgY>0) bgY -= drawH;

    for(let y=bgY; y<H; y+=drawH){
      ctx.drawImage(img, 0, y, W, drawH);
    }
  }

  function currentBG(){
    if(level===2) return IMG.bg2||IMG.bg1;
    if(level===3) return IMG.bg3||IMG.bg1;
    return IMG.bg1;
  }

  function scheduleOneUp(){ oneup=null; oneupSpawned=false; oneupTimer=rand(10,20); }
  function spawnOneUp(){
    let x=W/2,y=H/2,tries=0;
    do{
      x=rand(ONEUP_R+14, W-ONEUP_R-14);
      y=rand(ONEUP_R+90, H-ONEUP_R-20);
      tries++;
    } while(dist2(x,y,ship.x,ship.y)<220*220 && tries<80);
    oneup={ x:x,y:y,vx:rand(-25,25),vy:rand(-18,18),active:true };
    oneupSpawned=true;
  }

  const LEVEL2_ALIEN_CHANCE = 0.28;


// CHANGE START: Level 2 floater cap (exclude formation)
const L2_FLOATERS_MIN = 2;
const L2_FLOATERS_MAX = 3;

function isL2FormationEnemy(e){
  return !!(e && e.form && e.formId===1);
}

function countL2Floaters(){
  let c=0;
  for(const e of enemies){
    if(!isL2FormationEnemy(e)) c++;
  }
  return c;
}

function trimL2FloatersToMax(){
  let c=countL2Floaters();
  if(c<=L2_FLOATERS_MAX) return;
  for(let i=enemies.length-1;i>=0 && c>L2_FLOATERS_MAX;i--){
    const e=enemies[i];
    if(e && !isL2FormationEnemy(e)){
      enemies.splice(i,1);
      c--;
    }
  }
}

function fillL2FloatersToMin(){
  let c=countL2Floaters();
  while(c<L2_FLOATERS_MIN){
    enemies.push(makeEnemyFromEdge(3));
    c++;
  }
}
// CHANGE END
function pickEnemyKind(){
    if(level===2){
      const r=Math.random();
      if(r < LEVEL2_ALIEN_CHANCE) return "alien";
      return (Math.random() < DIFF.ufoChance) ? "ufo" : "smiley";
    }
    return (Math.random() < DIFF.ufoChance) ? "ufo" : "smiley";
  }

  function makeEnemyFromEdge(size, kindOverride){
    const radius=size===3?rand(54,72):size===2?rand(36,48):rand(24,32);
    const side=Math.floor(rand(0,4));
    let x,y,tx,ty;
    const margin=radius+30;

    if(side===0){ x=rand(0,W); y=-margin; }
    else if(side===1){ x=W+margin; y=rand(0,H); }
    else if(side===2){ x=rand(0,W); y=H+margin; }
    else { x=-margin; y=rand(0,H); }

    tx=rand(W*0.20, W*0.80);
    ty=rand(H*0.20, H*0.60);

    const levelSpeedMul=1+(level-1)*0.06;
    const baseSpeed=rand(55,130)*(4-size)*levelSpeedMul;
    const ang=Math.atan2(ty-y, tx-x) + rand(-0.30,0.30);

    const kind=(typeof kindOverride==="string") ? kindOverride : pickEnemyKind();

    let initAng = rand(0,Math.PI*2);
    let initSpin = rand(-0.75,0.75);
    if(kind==="ufo"){
      initAng = 0;
      initSpin = 0;
    }

    return {
      x:x,y:y,
      vx:Math.cos(ang)*baseSpeed,
      vy:Math.sin(ang)*baseSpeed,
      size:size,radius:radius,kind:kind,
      ang:initAng,
      spin:initSpin,
      shootCooldown: (kind==="ufo"||kind==="alien") ? rand(DIFF.ufoFireMin,DIFF.ufoFireMax) : 999999,
      swayT: rand(0, Math.PI*2),
      swaySpd: rand(0.8, 1.4)
    };
  }

  function spawnWave(n){
    const count=Math.min(n, DIFF.waveMax);
    for(let i=0;i<count;i++) enemies.push(makeEnemyFromEdge(3));
  }

  function spawnLevel2Formation(){
    enemies.length=0;
    lvl2Form={ x:W/2, y:-(H*0.28), speed:112, alive:true };

    const r=46;
    const gapX=r*2.35;
    const gapY=r*2.00;

    const rows=[5,4,3,2,1];
    for(let row=0; row<rows.length; row++){
      const n=rows[row];
      const totalW=(n-1)*gapX;
      const yOff = -gapY*(rows.length-1-row);
      for(let i=0;i<n;i++){
        const offX = -totalW/2 + i*gapX;

        const e = makeEnemyFromEdge(3, "ufo");
        e.radius=r;
        e.size=3;
        e.kind="ufo";
        e.spin=0;
        e.vx=0; e.vy=0;
        e.form=true;
        e.formId=1;
        e.offX=offX;
        e.offY=yOff;
        e.shootCooldown = rand(0.45, 1.15);
        enemies.push(e);
      }

    /* Level 2 mixed enemies (smiley + alien) — spawn alongside the formation from the start */
// Not part of the formation (they drift like normal enemies).
enemies.push(makeEnemyFromEdge(3, "smiley"));
enemies.push(makeEnemyFromEdge(3, "alien"));
    enemies.push(makeEnemyFromEdge(3, "alien"));
  }
  }

  function setMusicForState(){
    if(!audioUnlockedEver) return;

    // Show logo only on the Tap-to-Start (intro) screen
    if(logoIntro){
      if(state==="intro") logoIntro.classList.add("is-visible");
      else logoIntro.classList.remove("is-visible");
    }

    let url=null, vol=0;

    // Keep music continuous across Intro <-> Level 1/2 transitions.
    // Play the "load" track only once per page load; afterwards, Intro uses the Level 1/2 track.
    if(state==="intro") {
      if(!setMusicForState._playedLoadOnce){
        setMusicForState._playedLoadOnce = true;
        url=MUSIC_URL.load;    vol=MUSIC_GAIN.load;
      } else {
        url=MUSIC_URL.level12; vol=MUSIC_GAIN.level12;
      }
    }
    else if(state==="win") { url=MUSIC_URL.win;  vol=MUSIC_GAIN.win; }
    else if(state==="gameover"){
      setMusicForState._lastUrl="";
      BGM.stop();
      return;
    } else {
      if(level===3){ url=MUSIC_URL.boss;    vol=MUSIC_GAIN.boss; }
      else         { url=MUSIC_URL.level12;vol=MUSIC_GAIN.level12; }
    }

    // Keep the Level 1/2 track continuous (and avoid any accidental restarts)
    if(url && setMusicForState._lastUrl===url) return;
    setMusicForState._lastUrl = url || "";

    BGM.play(url, vol);
  }

  function shipSpawnY(){
    const oldY=H*0.62;
    const bottomY=H-(SHIP_R+14);
    return (oldY+bottomY)/2;
  }

  function bossPhase(){
    if(!boss) return 1;
    if(boss.hp >= 14) return 1;
    if(boss.hp >= 7)  return 2;
    return 3;
  }

  function bossFireRange(){
    const p=bossPhase();
    if(p===1) return { min:BOSS_FIRE1_MIN, max:BOSS_FIRE1_MAX };
    if(p===2) return { min:BOSS_FIRE2_MIN, max:BOSS_FIRE2_MAX };
    return { min:BOSS_FIRE3_MIN, max:BOSS_FIRE3_MAX };
  }

  function bossSprayRange(){
    const p=bossPhase();
    if(p===1) return { min:BOSS_SPRAY1_MIN, max:BOSS_SPRAY1_MAX };
    if(p===2) return { min:BOSS_SPRAY2_MIN, max:BOSS_SPRAY2_MAX };
    return { min:BOSS_SPRAY3_MIN, max:BOSS_SPRAY3_MAX };
  }

  function bossMoveMul(){
    const p=bossPhase();
    if(p===1) return 1.0;
    if(p===2) return BOSS_MOVE2_MUL;
    return BOSS_MOVE3_MUL;
  }

  function spawnBoss(){
    boss={
      x:W/2,
      y:-BOSS_SIZE*0.75,
      vy:BOSS_ENTRY_SPEED,
      phase:"enter",
      hp:BOSS_HITS_TO_WIN,
      fireT:rand(BOSS_FIRE1_MIN,BOSS_FIRE1_MAX),
      hoverT:0,
      hitFlash:0,
      sprayT:rand(BOSS_SPRAY1_FIRST_MIN, BOSS_SPRAY1_FIRST_MAX),
      exploding:false,
      exT:0,

      rageNext: rand(BOSS_RAGE_BURST_EVERY_MIN, BOSS_RAGE_BURST_EVERY_MAX),
      rageLeft: 0,
      rageGap: 0,
      rageFlashT: 0,

      // CHANGE START: boss phase 2 charge state
      chargeNext: rand(BOSS_CHARGE_EVERY_MIN, BOSS_CHARGE_EVERY_MAX),
      charging:false,
      chargeT:0,
      cvx:0,
      cvy:0,
      // CHANGE END

      // CHANGE START: boss shield mechanic
      shieldOn:false,
      shieldHP:0,
      hitsSinceShield:0,
      nextShieldAt: randInt(5,8)
      // CHANGE END
    };
    triggerShake(0.75, isMobile ? 10 : 14);
  }

  function startLevel(){
    // Hide logo during gameplay
    if(logoIntro) logoIntro.classList.remove("is-visible");
    setGameplayWorldSize();
    playerLasers=[]; enemyLasers=[]; enemies=[]; boss=null; oneup=null; lvl2Form=null;
    // CHANGE START: clear boss trail
    bossTrail=[];
    // CHANGE END

    levelScore=0;
    ship.x=W/2;
    ship.y=shipSpawnY();
    ship.vx=0; ship.vy=0;
    ship.ang=-Math.PI/2;
    ship.invuln=DIFF.shipInvulnOnRespawn;
    ship.hitFlash=0;
    ship.cooldown=0;

    shieldActive=false;
    if(restartBtn) restartBtn.classList.remove("shieldOn");

    scheduleOneUp();
    resetScrollBG();

    scheduleSniper();

    bossFailSafeUsed=false;

    if(level===3) spawnBoss();
    else if(level===2) spawnLevel2Formation();
    else spawnWave(DIFF.waveStart);

    setMusicForState();
  }

  function startIntro(){
    state="intro";
    // Show logo immediately on first intro/globe screen
    if(logoIntro) logoIntro.classList.add("is-visible");
    syncControlsUI();
    introT=0;
    playerLasers=[]; enemyLasers=[]; enemies=[];
    boss=null; oneup=null; lvl2Form=null;

    setIntroWorldSize();
    startGate=!audioUnlockedEver;
    if(!startGate) setMusicForState();
    hud.textContent=" ";

    shieldActive=false;
    if(restartBtn) restartBtn.classList.remove("shieldOn");

    scheduleSniper();
  }

  function reset(withIntro){
    withIntro = !!withIntro;
    level=1; lives=4; levelScore=0; totalScore=0;
    if(withIntro) startIntro();
    else { state="playing"; syncControlsUI(); startLevel(); }
    focusGame();
  }

  function addPoints100(){ levelScore+=100; totalScore+=100; }

  function shootPlayer(){
    if(state!=="playing") return;
    if(ship.cooldown>0) return;
    ship.cooldown=DIFF.playerFireCooldown;

    const ax=Math.cos(ship.ang), ay=Math.sin(ship.ang);
    playerLasers.push({
      px: ship.x, py: ship.y,
      x: ship.x+ax*ship.r, y: ship.y+ay*ship.r,
      vx: ship.vx+ax*DIFF.playerLaserSpeed,
      vy: ship.vy+ay*DIFF.playerLaserSpeed,
      life: DIFF.playerLaserLife
    });
    playShootSfx();
  }

  function shootUFO(a){
    if(enemyLasers.length>=DIFF.maxEnemyLasers) return;
    const base=Math.atan2(ship.y-a.y, ship.x-a.x);
    const spread=a.size===3?0.55:a.size===2?0.42:0.34;
    const ang=base+rand(-spread,spread);
    const ax=Math.cos(ang), ay=Math.sin(ang);
    const levelLaserMul=1+(level-1)*0.05;

    enemyLasers.push({
      px:a.x, py:a.y,
      x:a.x+ax*(a.radius*0.95), y:a.y+ay*(a.radius*0.95),
      vx:ax*(DIFF.enemyLaserSpeed*levelLaserMul),
      vy:ay*(DIFF.enemyLaserSpeed*levelLaserMul),
      life: DIFF.enemyLaserLife
    });
  }

  function bossFire(){
    if(!boss || boss.exploding) return;
    const aimX=ship.x+rand(-150,150);
    const aimY=ship.y+rand(-80,80);
    const dx=aimX-boss.x;
    const dy=aimY-(boss.y+BOSS_R*0.25);
    const ang=Math.atan2(dy,dx);
    const ax=Math.cos(ang), ay=Math.sin(ang);

    enemyLasers.push({
      px: boss.x, py: boss.y,
      x: boss.x+ax*26,
      y: boss.y+BOSS_R*0.25+ay*26,
      vx: ax*440,
      vy: ay*440,
      life: 1.25
    });
  }

  function bossSpray(){
    if(!boss || boss.exploding) return;

    const originX=boss.x;
    const originY=boss.y + BOSS_R*0.12;

    const base=rand(0,Math.PI*2);
    const n=BOSS_SPRAY_BULLETS;
    for(let i=0;i<n;i++){
      const ang=base+(i/n)*Math.PI*2+rand(-0.05,0.05);
      const ax=Math.cos(ang), ay=Math.sin(ang);
      enemyLasers.push({
        px: originX, py: originY,
        x: originX + ax*28,
        y: originY + ay*28,
        vx: ax*BOSS_SPRAY_SPEED,
        vy: ay*BOSS_SPRAY_SPEED,
        life: 1.35
      });
    }
    triggerShake(0.22, isMobile ? 6 : 8);
  }

  function explodeEnemy(idx){
    const ex = enemies[idx];
    if(ex){ spawnRedBurst(ex.x, ex.y, clamp(ex.radius/42, 0.8, 1.6)); }
    enemies.splice(idx,1);
    addPoints100();

    if(level===2 && enemies.length<=6){
      if(enemies.length===0){
        spawnWave(3);
      } else if(enemies.length===6){
        for(let i=0;i<2;i++) enemies.push(makeEnemyFromEdge(3));
      }
      return;
    }
    if(enemies.length===0 && level!==3) spawnWave(DIFF.waveStart);
  }

  function triggerLevelClear(){
    state="levelclear";
    syncControlsUI();
    levelClearT=0;
    SFX.play("clear",{ volume:0.85, rate:1.0 });
    setMusicForState();
  }

  function triggerWin(){
    state="win";
    syncControlsUI();
    SFX.play("clear",{ volume:0.95, rate:1.0 });
    setMusicForState();
  }

  function killShip(){
    lives--;
    ship.x=W/2; ship.y=shipSpawnY(); ship.vx=0; ship.vy=0; ship.ang=-Math.PI/2;
    ship.invuln=DIFF.shipInvulnOnRespawn;
    ship.hitFlash=0.55;
    SFX.play("hit",{ volume:0.9, rate:1.0 });
    spawnShockwave(ship.x, ship.y);

    if(lives<=0){
      state="gameover";
      syncControlsUI();
      SFX.play("over",{ volume:1.0, rate:1.0 });
      setMusicForState();
    }
  }

  function grantLife(){
    lives=Math.min(lives+1,9);
    SFX.play("clear",{ volume:0.55, rate:1.1 });
  }

  function drawBossUIRight(){
    if(!boss) return;
    const pct=clamp(boss.hp/BOSS_HITS_TO_WIN,0,1);
    const pad=16, barW=14, barH=H*0.46;
    const x=W-pad-barW, y=(H-barH)/2;

    ctx.save();
    ctx.fillStyle="rgba(0,0,0,.45)";
    ctx.fillRect(x-10,y-16,barW+20,barH+32);
    ctx.strokeStyle="rgba(255,43,214,.55)";
    ctx.lineWidth=2;
    ctx.strokeRect(x-10,y-16,barW+20,barH+32);

    ctx.fillStyle="rgba(255,255,255,.18)";
    ctx.fillRect(x,y,barW,barH);

    ctx.fillStyle="rgba(255,43,214,.85)";
    const fh=barH*pct;
    ctx.fillRect(x,y+(barH-fh),barW,fh);

    ctx.fillStyle="#fff";
    ctx.font='900 12px "Orbitron", system-ui';
    ctx.textAlign="center";
    ctx.save(); ctx.translate(x+barW/2,y-2); ctx.rotate(-Math.PI/2);
    ctx.fillText("BOSS",0,0);
    ctx.restore();
    ctx.restore();
  }

  function drawGetReadyFlashOverGlobe(cx,cy){
    const blink=0.5+0.5*Math.sin(performance.now()*0.012);
    const alpha=0.12+0.68*blink;
    ctx.save();
    ctx.globalAlpha=alpha;
    ctx.fillStyle="#ff7a00";
    ctx.textAlign="center";
    ctx.font='900 40px "Orbitron", system-ui';
    ctx.fillText("GET READY", cx, cy+6);
    ctx.restore();
  }

  function drawIntroCountdownBelowGlobe(cx,cy,globeSize,secondsLeft){
    const t=Math.max(0, Math.ceil(secondsLeft));
    ctx.save();
    ctx.globalAlpha=0.95;
    ctx.fillStyle="#ff7a00";
    ctx.textAlign="center";
    ctx.font='900 18px "Orbitron", system-ui';
    ctx.fillText("Loading Game in " + t, cx, cy + globeSize*0.36);
    ctx.restore();
  }

  function drawWinScreen(){
    if(IMG.winBg) drawCover(IMG.winBg);
    ctx.save();
    ctx.fillStyle="rgba(0,0,0,.45)";
    ctx.fillRect(0,0,W,H);
    ctx.restore();

    ctx.save();
    ctx.fillStyle="#fff";
    ctx.font='900 48px "Orbitron", system-ui';
    ctx.textAlign="center";
    ctx.fillText("YOU WIN", W/2, H/2 - 90);

    if(IMG.winAliens){
      const w=Math.min(W*0.66, 540);
      const ratio=(IMG.winAliens.naturalHeight/IMG.winAliens.naturalWidth)||0.6;
      const h=w*ratio;
      ctx.drawImage(IMG.winAliens, W/2 - w/2, H/2 - 68, w, h);
    }

    ctx.font='800 16px "Orbitron", system-ui';
    ctx.fillText("Tap TRY AGAIN or press R", W/2, H/2 + 120);
    ctx.restore();
  }

  function draw(dt){
    const sh=applyShake(dt);
    ctx.save();
    ctx.translate(sh.x, sh.y);

    drawVerticalLoopBG(currentBG(), dt, 55);

    for(const a of enemies){
      const size=a.radius*2;
      const img = (a.kind==="alien") ? IMG.alienEnemy : (a.kind==="ufo" ? IMG.ufo : IMG.smiley);
      if(img) drawSpriteCentered(img,a.x,a.y,size,size,a.ang);
    }

  // CHANGE START: hard cap Level 2 floating enemies (exclude formation)
  if(level===2){
    trimL2FloatersToMax();
    fillL2FloatersToMin();
  }
  // CHANGE END

    if(sniper && IMG.ufo){
      const s = sniper.r*2;
      drawSpriteCentered(IMG.ufo, sniper.x, sniper.y, s, s, 0);
    }

        // CHANGE START: draw boss charge trail (stage 2 charge) - boss hit-flash ghosts
    if(bossTrail.length){
      const ghostImg = (IMG.bossHit || IMG.boss);
      if(ghostImg){
        ctx.save();
        ctx.globalCompositeOperation="lighter";
        for(const t of bossTrail){
          const u = Math.max(0, Math.min(1, t.life / t.ttl));      // 0..1
          const a = (1-u);
          const pulse = 1 + Math.sin((u*12) + (t.seed||0)) * 0.06; // subtle pulse
          ctx.globalAlpha = a * 0.55;
          drawSpriteCentered(ghostImg, t.x, t.y, BOSS_SIZE*pulse, BOSS_SIZE*pulse, 0);
        }
        ctx.restore();
      }
    }
    // CHANGE END

if(boss){
      let bossImg = IMG.boss;

      if(boss.exploding){
        const t=boss.exT;
        if(t < BOSS_EX_STAGE) bossImg = IMG.bossEx1 || IMG.boss;
        else if(t < BOSS_EX_STAGE*2) bossImg = IMG.bossEx2 || IMG.boss;
        else bossImg = IMG.bossEx3 || IMG.boss;
      } else {
        const p = bossPhase();

        if(p===3 && IMG.bossHit){
          const strobe = Math.sin(boss.rageFlashT * (Math.PI*2) * 10);
          if(strobe > 0) bossImg = IMG.bossHit;
        }

        if(boss.hitFlash>0 && IMG.bossHit){
          bossImg = IMG.bossHit;
        }

        // CHANGE START: use shield sprite while shield is on
        if(boss.shieldOn && IMG.bossShield){
          bossImg = IMG.bossShield;
        }
        // CHANGE END
      }

      // CHANGE START: pulsing glow while boss shield is on
      if(boss.shieldOn && IMG.bossShield){
        const pulse = 0.70 + 0.30*(0.5+0.5*Math.sin(performance.now()*0.02));
        ctx.save();
        ctx.globalCompositeOperation = "lighter";
        ctx.globalAlpha = pulse * 0.85;
        drawSpriteCentered(IMG.bossShield, boss.x, boss.y, BOSS_SIZE*1.06, BOSS_SIZE*1.06, 0);
        ctx.globalAlpha = pulse * 0.35;
        drawSpriteCentered(IMG.bossShield, boss.x, boss.y, BOSS_SIZE*1.16, BOSS_SIZE*1.16, 0);
        ctx.restore();
      }
      // CHANGE END

      if(bossImg) drawSpriteCentered(bossImg, boss.x, boss.y, BOSS_SIZE, BOSS_SIZE, 0);
      drawBossUIRight();
    }

    if(oneup && oneup.active && IMG.oneup){
      drawSpriteCentered(IMG.oneup, oneup.x, oneup.y, ONEUP_SIZE, ONEUP_SIZE, 0);
    }

    /* red explosion particles (enemies only) */
    if(particles.length){
      ctx.save();
      ctx.fillStyle = "#ff2b2b";
      for(const p of particles){
        const t = 1 - (p.life / p.ttl);
        ctx.globalAlpha = Math.max(0, Math.min(1, t));
        ctx.beginPath();
        ctx.arc(p.x, p.y, p.r, 0, Math.PI*2);
        ctx.fill();
      }
      ctx.restore();
    }

    /* orange shockwave when ship loses a life */
    if(shockwaves.length){
      ctx.save();
      ctx.globalCompositeOperation = "lighter";
      for(const s of shockwaves){
        const t = 1 - (s.life / s.ttl);
        const a = Math.max(0, Math.min(1, t));
        const col = s.col || "#ff7a00";

        ctx.globalAlpha = a * 0.95;
        ctx.strokeStyle = col;
        ctx.lineWidth = Math.max(2, s.thick * (0.45 + 0.55*a));
        ctx.shadowColor = col;
        ctx.shadowBlur = 18;

        ctx.beginPath();
        ctx.arc(s.x, s.y, s.r, 0, Math.PI*2);
        ctx.stroke();

        ctx.globalAlpha = a * 0.35;
        ctx.lineWidth = Math.max(2, s.thick * 0.35);
        ctx.shadowBlur = 0;
        ctx.beginPath();
        ctx.arc(s.x, s.y, s.r + (10*(1-a)), 0, Math.PI*2);
        ctx.stroke();
      }
      ctx.restore();
    }
    ctx.save();
    ctx.lineWidth=5;
    ctx.lineJoin="round";
    ctx.lineCap="round";

    ctx.strokeStyle=COL.playerLaser;
    for(const b of playerLasers) drawLaser(b);

    ctx.strokeStyle=COL.enemyLaser;
    for(const b of enemyLasers)  drawLaser(b);

    ctx.restore();

    const thrusting=!!keys["ArrowUp"];
    const shipImgNormal=thrusting ? IMG.shipThr : IMG.ship;
    const shipImg=(ship.hitFlash>0 && IMG.shipHit) ? IMG.shipHit : shipImgNormal;

    const invFlick = ship.invuln>0 ? (0.35 + 0.65*(0.5+0.5*Math.sin(performance.now()*0.03))) : 1;

    if(shipImg){
      ctx.save();
      ctx.globalAlpha = invFlick;
      drawSpriteCentered(shipImg, ship.x, ship.y, SHIP_SIZE, SHIP_SIZE, ship.ang + Math.PI/2);
      ctx.restore();
    }

    /* Shield overlay */
    if(state==="playing" && shieldActive && IMG.shipShield){
      const pulse = 0.72 + 0.28*(0.5+0.5*Math.sin(performance.now()*0.02));
      ctx.save();
      ctx.globalAlpha = pulse;
      drawSpriteCentered(IMG.shipShield, ship.x, ship.y, SHIP_SIZE*1.18, SHIP_SIZE*1.18, ship.ang + Math.PI/2);
      ctx.restore();
    }

    ctx.restore();

    if(state==="playing"){
      hud.textContent="SCORE " + Math.floor(levelScore) + "/2000   LIVES " + lives + "   LVL " + level;
    } else if(state==="levelclear"){
      hud.textContent="SCORE " + Math.floor(levelScore) + "/2000   LIVES " + lives + "   LVL " + level;
      ctx.save();
      ctx.fillStyle="rgba(0,0,0,.55)";
      ctx.fillRect(0,0,W,H);
      ctx.fillStyle="#fff";
      ctx.font='900 44px "Orbitron", system-ui';
      ctx.textAlign="center";
      ctx.fillText("LEVEL CLEARED", W/2, H/2 - 10);
      ctx.font='800 16px "Orbitron", system-ui';
      ctx.fillText("Loading next level…", W/2, H/2 + 22);
      ctx.restore();
    } else if(state==="win"){
      hud.textContent="SCORE " + Math.floor(levelScore) + "/2000   LIVES " + lives + "   LVL " + level;
      drawWinScreen();
    } else if(state==="gameover"){
      hud.textContent="GAME OVER   SCORE " + Math.floor(totalScore);
      ctx.save();
      ctx.fillStyle="rgba(0,0,0,.55)";
      ctx.fillRect(0,0,W,H);

      ctx.fillStyle=TEAL;
      ctx.font='900 44px "Orbitron", system-ui';
      ctx.textAlign="center";
      ctx.fillText("GAME OVER", W/2, H/2 - 70);

      if(IMG.gameOver){
        const w=Math.min(W*0.62, 520);
        const ratio=(IMG.gameOver.naturalHeight/IMG.gameOver.naturalWidth)||0.55;
        const h=w*ratio;
        ctx.drawImage(IMG.gameOver, W/2 - w/2, H/2 - 45, w, h);
      }

      ctx.font='800 16px "Orbitron", system-ui';
      ctx.fillText("Tap TRY AGAIN or press R", W/2, H/2 + 120);
      ctx.restore();
    }
  }

  /* ===== INPUT ===== */
  function bindBtn(id, code, tapFn){
    const el=document.getElementById(id);
    const down=function(e){ e.preventDefault(); onGesture(); if(code) keys[code]=true; if(tapFn) tapFn(); };
    const up  =function(e){ e.preventDefault(); if(code) keys[code]=false; };
    el.addEventListener('touchstart', down, { passive:false });
    el.addEventListener('pointerdown', down, { passive:false });
    el.addEventListener('touchend', up, { passive:false });
    el.addEventListener('pointerup', up, { passive:false });
    el.addEventListener('pointercancel', up, { passive:false });
    el.addEventListener('lostpointercapture', up, { passive:false });
    el.addEventListener('pointerleave', up, { passive:false });
  }

  bindBtn('t7cLeft','ArrowLeft');
  bindBtn('t7cRight','ArrowRight');
  bindBtn('t7cThrust','ArrowUp');
  bindBtn('t7cShoot','Space', function(){ shootPlayer(); });

  /* SHIELD button: hold/tap to protect during play; TRY AGAIN on end screens */
  (function(){
    const el = restartBtn;
    if(!el) return;

    function setShield(on){
      shieldActive = !!on && (state==="playing");
      el.classList.toggle("shieldOn", shieldActive);
    }

    function down(e){
      e.preventDefault();
      onGesture();
      if(state==="gameover" || state==="win"){
        reset(true);
        return;
      }
      setShield(true);
    }

    function up(e){
      e.preventDefault();
      setShield(false);
    }

    el.addEventListener('touchstart', down, { passive:false });
    el.addEventListener('pointerdown', down, { passive:false });
    el.addEventListener('touchend', up, { passive:false });
    el.addEventListener('pointerup', up, { passive:false });
    el.addEventListener('pointercancel', up, { passive:false });
    el.addEventListener('lostpointercapture', up, { passive:false });
    el.addEventListener('pointerleave', up, { passive:false });
  })();

  const touch={ activeId:null, dragging:false, moved:false, downT:0 };

  function canvasToGameXY(clientX, clientY){
    const r=canvas.getBoundingClientRect();
    return { x:(clientX-r.left)/r.width*W, y:(clientY-r.top)/r.height*H };
  }

  function setShipFromPointer(gx,gy){
    const m=ship.r+6;
    gx=clamp(gx,m,W-m); gy=clamp(gy,m,H-m);
    const dx=gx-ship.x, dy=gy-ship.y;
    if((dx*dx+dy*dy)>4*4) ship.ang=Math.atan2(dy,dx);
    ship.x=gx; ship.y=gy; ship.vx=0; ship.vy=0;
  }

  canvas.addEventListener('pointerdown',function(e){
    if(!isMobile) return;
    e.preventDefault();
    onGesture();
    canvas.setPointerCapture(e.pointerId);
    touch.activeId=e.pointerId; touch.dragging=true; touch.moved=false; touch.downT=performance.now();
  },{ passive:false });

  canvas.addEventListener('pointermove',function(e){
    if(!isMobile) return;
    if(!touch.dragging || e.pointerId!==touch.activeId) return;
    e.preventDefault();
    const p=canvasToGameXY(e.clientX,e.clientY);
    touch.moved=true;
    if(state==="playing"){
      setShipFromPointer(p.x,p.y);
      keys["ArrowUp"]=false; keys["ArrowLeft"]=false; keys["ArrowRight"]=false;
    }
  },{ passive:false });

  canvas.addEventListener('pointerup',function(e){
    if(!isMobile) return;
    if(e.pointerId!==touch.activeId) return;
    e.preventDefault();
    const elapsed=performance.now()-touch.downT;
    if(state==="playing" && (!touch.moved && elapsed<320)) shootPlayer();
    touch.dragging=false; touch.activeId=null;
  },{ passive:false });

  canvas.addEventListener('pointercancel', function(){ touch.dragging=false; touch.activeId=null; });

  window.addEventListener('keydown',function(e){
    const tag=(document.activeElement && document.activeElement.tagName ? document.activeElement.tagName : "").toLowerCase();
    if(tag==="input"||tag==="textarea"||(document.activeElement && document.activeElement.isContentEditable)) return;
    keys[e.code]=true;
    if(e.code==="Space") e.preventDefault();
    if(e.code==="KeyR") reset(true);
  },{ passive:false });
  window.addEventListener('keyup',function(e){ keys[e.code]=false; });

  /* ===== LOOP ===== */
  let lastT=performance.now();

  function loop(now){
    const dt=clamp((now-lastT)/1000,0,0.05);
    lastT=now;

    if(state==="intro"){
      syncControlsUI();

      if(IMG.bg1) drawCover(IMG.bg1);

      const cx=W/2, cy=H*0.40;
      const globeSize=Math.min(W,H)*0.46;

      ctx.save(); ctx.globalAlpha=0.95;
      drawSpriteCentered(IMG.globe, cx, cy, globeSize, globeSize, 0);
      ctx.restore();

      ctx.save();
      ctx.globalAlpha=0.86;
      ctx.fillStyle="#fff";
      ctx.font='900 22px "Orbitron", system-ui';
      ctx.textAlign="center";
      ctx.fillText("THE SEVEN CONTINENTS", cx, cy + globeSize*0.60);
      ctx.restore();

      /* CONTROL GUIDE BOX */
      ctx.save();
      const boxW=W*0.78, boxH=(isMobile?155:170);
      const bx=(W-boxW)/2, by=clamp(H*0.70, 60, H-boxH-60);
      ctx.fillStyle="rgba(0,0,0,.45)";
      ctx.fillRect(bx,by,boxW,boxH);
      ctx.strokeStyle="rgba(255,43,214,.55)";
      ctx.lineWidth=2;
      ctx.strokeRect(bx,by,boxW,boxH);

      ctx.fillStyle="#fff";
      ctx.textAlign="left";
      ctx.font='900 16px "Orbitron", system-ui';
      ctx.fillText("CONTROLS", bx+16, by+28);

      ctx.font='800 14px "Orbitron", system-ui';
      if(!isMobile){
        ctx.fillText("← / →  Rotate",               bx+16, by+56);
        ctx.fillText("↑      JETS",                 bx+16, by+78);
        ctx.fillText("Space  Fire",                 bx+16, by+100);
        ctx.fillText("Hold   SHIELD",               bx+16, by+122);
        ctx.fillText("Or Use On-Screen Controls",   bx+16, by+146);
      } else {
        ctx.fillText("Drag  Move ship",             bx+16, by+56);
        ctx.fillText("Tap   Fire",                  bx+16, by+78);
        ctx.fillText("Hold  SHIELD",                bx+16, by+100);
        ctx.fillText("Or Use On-Screen Controls",   bx+16, by+126);
      }
      ctx.restore();

      if(startGate){
        hud.textContent=" ";
        ctx.save();
        ctx.fillStyle="rgba(0,0,0,.55)";
        ctx.fillRect(0,0,W,H);
        ctx.fillStyle="#fff";
        ctx.textAlign="center";
        ctx.font='900 44px "Orbitron", system-ui';
        ctx.fillText("TAP TO START", W/2, H/2);
        ctx.restore();
        requestAnimationFrame(loop);
        return;
      }

      hud.textContent="GET READY";
      drawGetReadyFlashOverGlobe(cx, cy);
      drawIntroCountdownBelowGlobe(cx, cy, globeSize, Math.max(0, INTRO_SECONDS - introT));

      introT += dt;
      if(introT>=INTRO_SECONDS){
        level=1; lives=4; levelScore=0; totalScore=0;
        state="playing";
        syncControlsUI();
        startLevel();
        focusGame();
      }

      requestAnimationFrame(loop);
      return;
    }

    if(state==="levelclear"){
      levelClearT += dt;
      if(levelClearT>=1.4){
        if(level>=LEVELS_TO_WIN) triggerWin();
        else { level++; state="playing"; syncControlsUI(); startLevel(); }
      }
      draw(dt);
      requestAnimationFrame(loop);
      return;
    }

    if(state==="win"){
      draw(dt);
      requestAnimationFrame(loop);
      return;
    }

    if(state==="playing"){
      /* FAILSAFE: if Level 3 starts and boss is missing, spawn it once */
      if(level===3 && !boss && !bossFailSafeUsed){
        bossFailSafeUsed = true;
        spawnBoss();
        setMusicForState();
      }

      if(keys["Space"]) shootPlayer();

      if(keys["ArrowLeft"])  ship.ang -= DIFF.shipTurnSpeed*dt;
      if(keys["ArrowRight"]) ship.ang += DIFF.shipTurnSpeed*dt;

      if(keys["ArrowUp"]){
        ship.vx += Math.cos(ship.ang)*DIFF.shipThrust*dt;
        ship.vy += Math.sin(ship.ang)*DIFF.shipThrust*dt;
      }

      const fr=Math.pow(DIFF.shipFriction, dt*60);
      ship.vx*=fr; ship.vy*=fr;
      ship.x+=ship.vx*dt; ship.y+=ship.vy*dt;

      const m=ship.r+6;
      if(ship.x<m){ ship.x=m; ship.vx=Math.abs(ship.vx)*0.15; }
      if(ship.x>W-m){ ship.x=W-m; ship.vx=-Math.abs(ship.vx)*0.15; }
      if(ship.y<m){ ship.y=m; ship.vy=Math.abs(ship.vy)*0.15; }
      if(ship.y>H-m){ ship.y=H-m; ship.vy=-Math.abs(ship.vy)*0.15; }

      ship.cooldown=Math.max(0, ship.cooldown-dt);
      ship.invuln=Math.max(0, ship.invuln-dt);
      ship.hitFlash=Math.max(0, ship.hitFlash-dt);

      if(level===1 || level===2){
        if(!sniper){
          sniperTimer -= dt;
          if(sniperTimer<=0){
            spawnSniper();
          }
        } else {
          sniper.x += sniper.vx*dt;
          sniper.y += sniper.vy*dt;

          const rr = sniper.r;
          if(sniper.x<-rr) sniper.x=W+rr;
          if(sniper.x>W+rr) sniper.x=-rr;
          if(sniper.y<-rr) sniper.y=H+rr;
          if(sniper.y>H+rr) sniper.y=-rr;

          sniper.fireT -= dt;
          if(sniper.fireT<=0){
            sniperFire();
            sniper.fireT = rand(SNIPER.fireMin, SNIPER.fireMax);
          }
        }
      } else {
        sniper=null;
      }

      if(!oneupSpawned){ oneupTimer-=dt; if(oneupTimer<=0) spawnOneUp(); }
      if(oneup && oneup.active){
        oneup.x+=oneup.vx*dt; oneup.y+=oneup.vy*dt;
        if(oneup.x<-ONEUP_R) oneup.x=W+ONEUP_R;
        if(oneup.x>W+ONEUP_R) oneup.x=-ONEUP_R;
        if(oneup.y<-ONEUP_R) oneup.y=H+ONEUP_R;
        if(oneup.y>H+ONEUP_R) oneup.y=-ONEUP_R;
      }

      for(let i=playerLasers.length-1;i>=0;i--){
        const b=playerLasers[i];
        b.px=b.x; b.py=b.y;
        b.x+=b.vx*dt; b.y+=b.vy*dt; b.life-=dt;
        if(b.life<=0 || laserOut(b)) playerLasers.splice(i,1);
      }
      for(let i=enemyLasers.length-1;i>=0;i--){
        const b=enemyLasers[i];
        b.px=b.x; b.py=b.y;
        b.x+=b.vx*dt; b.y+=b.vy*dt; b.life-=dt;
        if(b.life<=0 || laserOut(b)) enemyLasers.splice(i,1);
      }
      /* update particles */
      for(let i=particles.length-1;i>=0;i--){
        const p=particles[i];
        p.life += dt;
        if(p.life >= p.ttl){
          particles.splice(i,1);
          continue;
        }
        // light drag + gravity-ish drift
        p.vx *= Math.pow(0.90, dt*60);
        p.vy *= Math.pow(0.90, dt*60);
        p.vy += 160*dt;
        p.x += p.vx*dt;
        p.y += p.vy*dt;
      }

      /* update shockwaves (orange ring when ship loses a life) */
      for(let i=shockwaves.length-1;i>=0;i--){
        const s=shockwaves[i];
        s.life += dt;
        if(s.life >= s.ttl){ shockwaves.splice(i,1); continue; }
        s.r += s.spd * dt;
      }

      // CHANGE START: update boss charge trail
      for(let i=bossTrail.length-1;i>=0;i--){
        const t=bossTrail[i];
        t.life += dt;
        if(t.life >= t.ttl){ bossTrail.splice(i,1); continue; }
        t.r += 90*dt;
      }
      // CHANGE END

      if(level===2 && lvl2Form && lvl2Form.alive){
        lvl2Form.y += lvl2Form.speed*dt;
        for(const a of enemies){
          if(a.form && a.formId===1){
            a.x = lvl2Form.x + a.offX;
            a.y = lvl2Form.y + a.offY;
            a.ang = 0;
          }
        }
      }

      for(const a of enemies){
        if(!(level===2 && a.form && a.formId===1)){
          if(a.kind==="ufo"){
            a.swayT += dt * a.swaySpd;

            const sp = Math.sqrt(a.vx*a.vx + a.vy*a.vy) || 1;
            const px = -a.vy / sp;
            const py =  a.vx / sp;

            const weave = Math.sin(a.swayT) * 28;
            a.vx += px * weave * dt;
            a.vy += py * weave * dt;

            const sp2 = Math.sqrt(a.vx*a.vx + a.vy*a.vy) || 1;
            a.vx = a.vx / sp2 * sp;
            a.vy = a.vy / sp2 * sp;
          }

          a.x+=a.vx*dt; a.y+=a.vy*dt;
          if(a.x<-a.radius) a.x=W+a.radius;
          if(a.x>W+a.radius) a.x=-a.radius;
          if(a.y<-a.radius) a.y=H+a.radius;
          if(a.y>H+a.radius) a.y=-a.radius;

          if(a.kind!=="ufo") a.ang += a.spin*dt;
          else a.ang = 0;
        }

        if(a.kind==="ufo" || a.kind==="alien"){
          a.shootCooldown-=dt;
          if(a.shootCooldown<=0){
            shootUFO(a);
            a.shootCooldown=rand(DIFF.ufoFireMin, DIFF.ufoFireMax);
          }
        }
      }

      if(boss){
        boss.hitFlash=Math.max(0, boss.hitFlash-dt);

        if(boss.exploding){
          boss.exT += dt;
          boss.vy *= 0.96;
          if(boss.exT >= BOSS_EXPL_TOTAL){
            boss=null;
            triggerWin();
          }
        } else {
          const p = bossPhase();
          const moveMul = bossMoveMul();

          if(p===3){
            shakeT = Math.max(shakeT, 0.08);
            shakeAmp = Math.max(shakeAmp, isMobile ? 10 : 14);
            boss.rageFlashT += dt;
          }

          // CHANGE START: boss phase 2 charge move

          // charge can happen in all phases (except during enter/exploding)
          if(boss.phase!=="enter" && !boss.exploding){
            boss.chargeNext -= dt;
            if(!boss.charging && boss.chargeNext<=0){
              boss.charging=true;
              boss.chargeT=0;
              const dx=ship.x - boss.x;
              const dy=ship.y - boss.y;
              const d=Math.max(1, Math.hypot(dx,dy));
              boss.cvx = (dx/d) * BOSS_CHARGE_SPEED;
              boss.cvy = (dy/d) * BOSS_CHARGE_SPEED;
              triggerShake(0.18, isMobile ? 7 : 9);
            }
          }
          if(boss.phase==="enter"){
            boss.y += boss.vy*dt;
            if(boss.y>=BOSS_HOVER_Y){
              boss.y=BOSS_HOVER_Y;
              boss.phase="hover";
              boss.hoverT=0;
              triggerShake(0.35, isMobile?8:10);
            }
          } else if(boss.charging){
            boss.chargeT += dt;
            boss.x += boss.cvx * dt;
            boss.y += boss.cvy * dt;

            spawnBossTrail(boss.x, boss.y);

            // touching the ship during charge costs a life
            const hitR = ship.r + (BOSS_SIZE*0.42);
            if(!shieldActive && ship.invuln<=0){
              const ddx = boss.x - ship.x;
              const ddy = boss.y - ship.y;
              if((ddx*ddx + ddy*ddy) <= (hitR*hitR)){
                killShip();
              }
            }

            if(boss.chargeT >= BOSS_CHARGE_DUR){
              boss.charging=false;
              boss.chargeNext = rand(BOSS_CHARGE_EVERY_MIN, BOSS_CHARGE_EVERY_MAX);
              boss.y = Math.min(boss.y, BOSS_HOVER_Y);
            }
          } else {
            boss.hoverT += dt * moveMul;
            boss.x = W/2 + Math.sin(boss.hoverT*0.9)*(W*0.18*moveMul);
          }
          // CHANGE END

          boss.fireT -= dt;
          if(boss.fireT<=0){
            bossFire();
            const fr = bossFireRange();
            boss.fireT = rand(fr.min, fr.max);
            if(p===3) triggerShake(0.10, isMobile ? 7 : 9);
          }

          boss.sprayT -= dt;
          if(boss.sprayT<=0){
            bossSpray();
            const sr = bossSprayRange();
            boss.sprayT = rand(sr.min, sr.max);
          }

          if(p===3){
            boss.rageNext -= dt;
            if(boss.rageLeft>0){
              boss.rageLeft -= dt;
              boss.rageGap -= dt;
              if(boss.rageGap<=0){
                bossFire();
                boss.rageGap = rand(BOSS_RAGE_SHOT_GAP_MIN, BOSS_RAGE_SHOT_GAP_MAX);
                triggerShake(0.06, isMobile ? 6 : 8);
              }
              if(boss.rageLeft<=0){
                boss.rageNext = rand(BOSS_RAGE_BURST_EVERY_MIN, BOSS_RAGE_BURST_EVERY_MAX);
              }
            } else if(boss.rageNext<=0){
              boss.rageLeft = rand(BOSS_RAGE_BURST_LEN_MIN, BOSS_RAGE_BURST_LEN_MAX);
              boss.rageGap  = 0;
            }
          }
        }
      }

      for(let i=enemies.length-1;i>=0;i--){
        const a=enemies[i];
        for(let j=playerLasers.length-1;j>=0;j--){
          const b=playerLasers[j];
          if(segHitsCircle(b.px,b.py,b.x,b.y,a.x,a.y,a.radius)){
            playerLasers.splice(j,1);
            explodeEnemy(i);
            break;
          }
        }
      }

      if(sniper){
        for(let j=playerLasers.length-1;j>=0;j--){
          const b=playerLasers[j];
          if(segHitsCircle(b.px,b.py,b.x,b.y,sniper.x,sniper.y,sniper.r)){
            playerLasers.splice(j,1);
            sniper.hp -= 1;
            SFX.play("hit",{ volume:0.35, rate:1.05 });
            if(sniper.hp<=0){
              spawnRedBurst(sniper.x, sniper.y, 1.3);
              addPoints100();
              sniper=null;
              sniperTimer = rand(SNIPER.spawnMin, SNIPER.spawnMax);
            }
            break;
          }
        }
      }

      // CHANGE START: boss shield hit handling (5–8 hits triggers shield; 5 hits break shield)
      if(boss && !boss.exploding){
        for(let j=playerLasers.length-1;j>=0;j--){
          const b=playerLasers[j];
          if(segHitsCircle(b.px,b.py,b.x,b.y,boss.x,boss.y,BOSS_R)){
            playerLasers.splice(j,1);

            // Shield is ON: hits only reduce shieldHP, not boss.hp
            if(boss.shieldOn){
              boss.shieldHP -= 1;
              boss.hitFlash=0.12;
              addPoints100();
              SFX.play("hit",{ volume:0.45, rate:1.05 });

              if(boss.shieldHP<=0){
                boss.shieldOn=false;
                boss.hitsSinceShield=0;
                boss.nextShieldAt = randInt(5,8);
                triggerShake(0.30, isMobile ? 8 : 10);
              }
              break;
            }

            // Shield is OFF: damage boss, count toward next shield trigger
            boss.hp-=1;
            boss.hitsSinceShield = (boss.hitsSinceShield||0) + 1;
            addPoints100();
            boss.hitFlash=0.12;
            SFX.play("hit",{ volume:0.45, rate:1.05 });

            if(boss.hp<=0){
              boss.exploding=true;
              boss.exT=0;
              enemyLasers.length=0;
              triggerShake(0.9, isMobile?10:14);
              SFX.play("over",{ volume:0.55, rate:0.9 });
              break;
            }

            // Trigger boss shield after 5–8 boss hits (not counting shield hits)
            if(boss.hitsSinceShield >= boss.nextShieldAt){
              boss.shieldOn=true;
              boss.shieldHP=5;
              boss.hitsSinceShield=0;
              boss.nextShieldAt = randInt(5,8);
              triggerShake(0.28, isMobile ? 8 : 10);
            }

            break;
          }
        }
      }
      // CHANGE END

      if(oneup && oneup.active){
        for(let j=playerLasers.length-1;j>=0;j--){
          const b=playerLasers[j];
          if(segHitsCircle(b.px,b.py,b.x,b.y,oneup.x,oneup.y,ONEUP_R)){
            playerLasers.splice(j,1);
            oneup.active=false;
            grantLife();
            break;
          }
        }
      }
      if(oneup && oneup.active){
        const r=SHIP_R+ONEUP_R;
        if(dist2(ship.x,ship.y,oneup.x,oneup.y) < r*r){
          oneup.active=false;
          grantLife();
        }
      }

      /* ===== SHIELD PROTECTION: LASERS + ENEMY TOUCH ===== */
      if(ship.invuln<=0){
        const r = SHIP_R + 18;
        for(let j=enemyLasers.length-1;j>=0;j--){
          const b=enemyLasers[j];
          if(segHitsCircle(b.px,b.py,b.x,b.y,ship.x,ship.y,r)){
            enemyLasers.splice(j,1);
            if(!shieldActive) killShip();
            break;
          }
        }
      }

      if(ship.invuln<=0){
        const rr = SHIP_R + 20;
        for(let i=enemies.length-1;i>=0;i--){
          const a=enemies[i];
          const r2 = rr + a.radius;
          if(dist2(ship.x,ship.y,a.x,a.y) < r2*r2){
            if(!shieldActive) killShip();
            break;
          }
        }
      }

      if(level!==3 && levelScore>=LEVEL_TARGET){
        triggerLevelClear();
      }
    }

    draw(dt);
    requestAnimationFrame(loop);
  }

  /* ===== BOOT ===== */
  (async function(){
    hud.textContent="LOADING…";
    try{
      const arr = await Promise.all([
        loadImage(ASSET.bg1),
        loadImage(ASSET.bg2),
        loadImage(ASSET.bg3),
        loadImage(ASSET.globe),
        loadImage(ASSET.smiley),
        loadImage(ASSET.ufo),
        loadImage(ASSET.ufoHit),
        loadImage(ASSET.alienEnemy),
        loadImage(ASSET.ship),
        loadImage(ASSET.shipThr),
        loadImage(ASSET.shipHit),
        loadImage(ASSET.oneup),
        loadImage(ASSET.gameOver),
        loadImage(ASSET.winAliens),
        loadImage(ASSET.winBg),
        loadImage(ASSET.boss),
        loadImage(ASSET.bossHit),
        loadImage(ASSET.bossEx1),
        loadImage(ASSET.bossEx2),
        loadImage(ASSET.bossEx3),
        loadImage(ASSET.shipShield),
        // CHANGE START: load boss shield sprite
        loadImage(ASSET.bossShield)
        // CHANGE END
      ]);

      IMG={
        bg1:arr[0],bg2:arr[1],bg3:arr[2],globe:arr[3],smiley:arr[4],ufo:arr[5],ufoHit:arr[6],alienEnemy:arr[7],
        ship:arr[8], shipThr:arr[9], shipHit:arr[10],
        oneup:arr[11],
        gameOver:arr[12],
        winAliens:arr[13], winBg:arr[14],
        boss:arr[15], bossHit:arr[16], bossEx1:arr[17], bossEx2:arr[18], bossEx3:arr[19],
        shipShield:arr[20],
        // CHANGE START: boss shield image handle
        bossShield:arr[21]
        // CHANGE END
      };

      await SFX.init();
      await Promise.all([
        SFX.load("hit",   SFX_ASSET.hit),
        SFX.load("over",  SFX_ASSET.over),
        SFX.load("clear", SFX_ASSET.clear),
        SFX.load("shoot", SFX_ASSET.shoot)
      ]);

      startIntro();
      focusGame();
      requestAnimationFrame(loop);
    } catch(err){
      hud.textContent="ASSET LOAD ERROR";
      try{ console.error(err); }catch(_){}
    }
  })();
})();